export default __webpack_public_path__ + "static/assets/600a1a2c5966e35d4c25a3d4c4a16d89.png";